import styled from "styled-components";

export const ButtonSecondary = styled.button`
    display: flex;
    height: 40px;
    padding: 0 24px;
    justify-content: center;
    align-items: center;
    gap: 12px;

    color: var(--it-text-white);
    background: var(--it-bg-buttons);
    /* Buttons big */
    font-family: "Basis Grotesque Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 16px */
    letter-spacing: 0.48px;
    text-transform: uppercase;
    border-radius: 1px;
    cursor: pointer;
    transition: all 0.4s;

    svg path {
        transition: all 0.4s;
        fill: var(--it-text-white);
    }
    
    &:hover {
        color: var(--it-text-black);
        background: var(--it-accent-blue);

        svg path {
            fill: var(--it-text-black);
        }
    }
		
		&[data-transparent] {
				padding: 10px;
				background: transparent;

        svg path {
            transition: all 0.4s;
            fill: var(--it-text-white);
        }
				
				&:hover {
						background: var(--it-bg-dark-2);
				}
		}

    &[data-icon] {
        padding: 10px;
        border: 1px solid transparent;
				
				&[data-active="true"] {
            border: 1px solid var(--it-accent-blue);
				}
    }
`